import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class HospitalStateService {

  private hospitalSubject = new BehaviorSubject<any>(null);
  hospital$ = this.hospitalSubject.asObservable();

  setHospital(data: any) {
    this.hospitalSubject.next(data);
  }

  getHospital() {
    return this.hospitalSubject.value;
  }

  clearHospital() {
    this.hospitalSubject.next(null);
  }
}
